import { Box } from '@osmosis/tailwind-ui/components/Box';
import Image from 'next/legacy/image';

import Link from 'next/link';

/**
 * AuthLogo.
 */
const AuthLogo = () => (
  <Box className={`mt-[20px] mb-[50px]`}>
    <Link tabIndex={-1} href="/">
      <Image alt="Osmosis Logo" src="/images/logo.png" width={88} height={38} />
    </Link>
  </Box>
);

export default AuthLogo;
